export const getCache = <T>(key: string) => {
  const item = sessionStorage.getItem(key);
  return item ? (JSON.parse(item) as T) : null;
};

export const setCache = <T>(key: string, value: T) =>
  sessionStorage.setItem(key, JSON.stringify(value));
